
import { defineComponent, onMounted, inject, reactive, ref } from "vue";
import { updateActiveLinkOnScroll } from "@/components/FixedNav/animate";
import { ActiveLinkContext } from "@/interfaces/nav";
import SectionHeader from "@/components/Shared/SectionHeader/SectionHeader.vue";
import ActionButton from "@/components/Shared/ActionButton/ActionButton.vue";
import socials from "@/fixtures/socials";
import animate from "@/components/GetInTouch/animate";
import emailjs from "@emailjs/browser";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default defineComponent({
  name: "GetInTouch",
  components: {
    SectionHeader,
    ActionButton,
    FontAwesomeIcon,
  },
  setup() {
    const { updateActiveLink } = inject("active-link") as ActiveLinkContext;
    const sendData = reactive({
      name: "",
      email: "",
      message: "",
    });
    const formError: { [key: string]: boolean } = reactive({
      name: false,
      email: false,
      message: false,
    });
    const result = reactive({
      loading: false,
      text: "",
    });
    const output_class = ref("");
    const sendEmail = () => {
      result.loading = true;

      emailjs
        .sendForm(
          process.env.VUE_APP_EMAIL_JS_SERVICE_ID,
          process.env.VUE_APP_EMAIL_JS_TEMPLATE_ID,
          "#contact__form",
          process.env.VUE_APP_EMAIL_JS_PUBLIC_KEY
        )
        .then(
          () => {
            result.loading = false;
            result.text =
              "Got it! I will reply as soon as possible. Thank you!";
            output_class.value = "form-success";
          },
          () => {
            result.loading = false;
            result.text =
              "There was a problem sending your request. You can try again later, or send me an e-mail";
            output_class.value = "form-error";
          }
        );
    };

    const validate = (e: Event) => {
      const target = e.target as HTMLInputElement | HTMLTextAreaElement | null;
      if (!target) return;

      const name = target.name;
      const email_regex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
      switch (name) {
        case "name":
          if (!target.value) formError.name = true;
          else if (formError.name) formError.name = false;
          break;
        case "email":
          if (!target.value.match(email_regex)) formError.email = true;
          else if (formError.email) formError.email = false;
          break;
        case "message":
          if (!target.value) formError.message = true;
          else if (formError.message) formError.message = false;
      }
    };

    onMounted(() => {
      updateActiveLinkOnScroll("#get-in-touch", updateActiveLink);
      animate();
    });

    return {
      socials,
      sendData,
      validate,
      formError,
      sendEmail,
      result,
      output_class,
    };
  },
});
